var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_262)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_262",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -5.34058e-05H75V74.9999H0V-5.34058e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1228 13.9364C27.3508 17.3411 23.6558 19.7832 19.4367 20.9986C18.0576 21.396 17.2616 22.8359 17.6588 24.2152C18.0336 25.5159 19.3357 26.2978 20.6394 26.0493C20.7182 26.0344 20.797 26.0157 20.8755 25.9931C23.0221 25.3748 25.0594 24.5004 26.9537 23.3933L30.1228 13.9364Z",
    fill: "#00CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5187 29.9185L40.3482 21.8359C41.2018 21.9685 42.0591 22.0366 42.9136 22.0366C46.7655 22.0366 50.5492 20.7032 53.5905 18.1769L53.9393 17.887C55.0231 16.9866 55.2461 15.377 54.3849 14.2618C53.4808 13.0908 51.7942 12.912 50.6658 13.8495L50.2691 14.1791C49.5922 14.7413 48.8619 15.2178 48.0938 15.6054C45.0984 17.1165 41.4987 16.3341 39.2163 13.875C38.0995 12.6717 36.503 11.9077 34.704 11.9077C31.8994 11.9077 29.4487 13.8023 28.7427 16.5167L25.2563 29.9185H37.5187Z",
    fill: "#00CCF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2562 29.9185L15.0134 56.7771C14.3481 58.5216 15.482 60.4308 17.3323 60.6811L17.4005 60.6903C18.667 60.8619 19.8868 60.2195 20.455 59.0929C23.3517 53.3496 31.9032 36.4422 31.9032 36.4422H35.3759L33.6049 47.5767C33.3429 49.2248 34.6162 50.7169 36.285 50.7169C37.5036 50.7169 38.5728 49.9047 38.8995 48.7306L42.228 36.7709C43.1865 33.3272 40.5969 29.9185 37.0223 29.9185H35.4369H25.2562Z",
    fill: "#FFBE52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5352 32.5796L60.9106 35.1204L63.6544 37.8642L54.8794 46.6392L48.6544 40.414L19.7321 69.3366L23.9337 73.538L48.6544 48.8173L54.8794 55.0424L67.8561 42.0658L70.9944 45.2042L73.5352 32.5796Z",
    fill: "#FF6371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5352 32.5796L60.9106 35.1204L63.6544 37.8642L54.8794 46.6392L48.6544 40.414L19.7321 69.3366L23.9337 73.538L48.6544 48.8173L54.8794 55.0424L67.8561 42.0658L70.9944 45.2042L73.5352 32.5796Z",
    fill: "#FF6371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1228 13.9364C27.3508 17.3411 23.6558 19.7832 19.4367 20.9986C18.0576 21.396 17.2616 22.8359 17.6588 24.2152C18.0336 25.5159 19.3357 26.2978 20.6394 26.0493C20.7182 26.0344 20.797 26.0157 20.8755 25.9931C23.0221 25.3748 25.0594 24.5004 26.9537 23.3933",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5187 29.9185L40.3482 21.8359C41.2018 21.9685 42.0591 22.0366 42.9136 22.0366C46.7655 22.0366 50.5492 20.7032 53.5905 18.1769L53.9393 17.887C55.0231 16.9866 55.2461 15.377 54.3849 14.2618C53.4808 13.0908 51.7942 12.912 50.6658 13.8495L50.2691 14.1791C49.5922 14.7413 48.8619 15.2178 48.0938 15.6054C45.0984 17.1165 41.4987 16.3341 39.2163 13.875C38.0995 12.6717 36.503 11.9077 34.704 11.9077C31.8994 11.9077 29.4487 13.8023 28.7427 16.5167L25.2563 29.9185H37.5187Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2973 57.1744L48.6544 48.8173L54.8795 55.0425L67.8561 42.0659L70.9946 45.2043L73.5352 32.5797L60.9106 35.1203L63.6545 37.8643L54.8795 46.6393L48.6544 40.4141L19.7321 69.3366L23.9337 73.538L32.0108 65.4609",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7279 6.68481C43.7279 3.80024 41.3896 1.46191 38.505 1.46191C35.6204 1.46191 33.2821 3.80024 33.2821 6.68481C33.2821 9.56938 35.6204 11.9077 38.505 11.9077C41.3896 11.9077 43.7279 9.56938 43.7279 6.68481Z",
    fill: "#FED2A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7279 6.68481C43.7279 3.80024 41.3896 1.46191 38.505 1.46191C35.6204 1.46191 33.2821 3.80024 33.2821 6.68481C33.2821 9.56938 35.6204 11.9077 38.505 11.9077C41.3896 11.9077 43.7279 9.56938 43.7279 6.68481Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.916 54.4103L15.0134 56.777C14.3481 58.5217 15.4822 60.4308 17.3323 60.6811L17.4007 60.6904C18.667 60.8617 19.8869 60.2196 20.4552 59.0929C23.3519 53.3496 31.9032 36.4422 31.9032 36.4422H35.3761L33.6051 47.5768C33.3428 49.2249 34.6162 50.7168 36.2851 50.7168C37.5037 50.7168 38.5729 49.9046 38.8996 48.7306L42.2281 36.7709C43.1864 33.3271 40.5969 29.9185 37.0224 29.9185H35.4368",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2563 29.9185L20.0924 43.4592",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8555 40.9113L2.02947 30.0852C1.28591 29.3417 1.28591 28.1358 2.02947 27.3922L9.88791 19.5338C10.6316 18.7901 11.8373 18.7901 12.581 19.5338L23.407 30.3599C24.1507 31.1034 24.1507 32.3091 23.407 33.0528L15.5487 40.9113C14.805 41.655 13.5992 41.655 12.8555 40.9113Z",
    fill: "#FF9357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1149 31.9165L10.667 31.4686C9.88021 30.6818 9.88021 29.4061 10.667 28.6192L12.5396 26.7465L15.837 30.0439L13.9643 31.9165C13.1776 32.7034 11.9018 32.7034 11.1149 31.9165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8555 40.9113L2.02947 30.0852C1.28591 29.3417 1.28591 28.1358 2.02947 27.3922L9.88791 19.5338C10.6316 18.7901 11.8373 18.7901 12.581 19.5338L23.407 30.3599C24.1507 31.1034 24.1507 32.3091 23.407 33.0528L15.5487 40.9113C14.805 41.655 13.5992 41.655 12.8555 40.9113Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95874 23.463L10.891 28.3953",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1206 36.6249L14.1884 31.6926",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1149 31.9165L10.667 31.4686C9.88021 30.6818 9.88021 29.4061 10.667 28.6192L12.5396 26.7465L15.837 30.0439L13.9643 31.9165C13.1776 32.7034 11.9018 32.7034 11.1149 31.9165Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.34c4361106d7c8f30bf78844fa0d1aa3.svg";
export { ForwardRef as ReactComponent };